// extracted by mini-css-extract-plugin
export default {"simpleTitle":"LinkedSubMenu_simpleTitle__Faguq","linkTitle":"LinkedSubMenu_linkTitle__ReXM9","subItemsList":"LinkedSubMenu_subItemsList__1WAcF"};